import { RadioCard_default } from "./chunk-KRY2IVCV.js";
import { CheckableGroupComponent } from "./chunk-AUZ3GMLH.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/RadioCardGroup/RadioCardGroup.Field.tsx
import { forwardRef } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var RadioCardGroupField = forwardRef((_a, ref) => {
  var _b = _a,
    {
      className
    } = _b,
    rest = __objRest(_b, ["className"]);
  return /* @__PURE__ */jsx(CheckableGroupComponent.Field, __spreadValues({
    as: RadioCard_default,
    ref,
    className: clsx("pd:radio-card-group__field", className)
  }, rest));
});
var RadioCardGroup_Field_default = RadioCardGroupField;
export { RadioCardGroup_Field_default };